module.exports = __webpack_public_path__ + "img/ico-video-call.dda342d2.svg";